<header class="page__header" role="banner"></header>
<main class="page__content" role="main">
   <div class="dashboard"></div>
   <router-outlet></router-outlet>
</main>
<dashboard-footer></dashboard-footer>
